/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import ReactExport from 'react-export-excel';
import useStore from '../../../../store';
import c from '../../../../constant';
import { toFormatCurrency } from '../../../../utils/format';
import { fileNameSummarizedReport } from '../../../../components/MarketDevelopment/Miscellaneous/export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExcelSummarizedReportTotal({ tab, year, month, marketGrowthItem = null, ...props }) {
	const { t } = useTranslation();
	const [data, setData] = useState([]);
	const { currentLang: lang } = useStore((state) => state.currentLang);

	function formatCellValue(description, value) {
		const numericValue = Number(value) || 0;

		if (description === t('Number of Policies')) {
			return toFormatCurrency(numericValue, null, 0);
		}

		return toFormatCurrency(numericValue);
	}

	function makeRow(description, insuranceType, values = []) {
		const data = Array.isArray(values) ? values : [];
		return {
			description,
			insuranceType,
			...data.reduce((acc, val, index) => {
				acc[`month_${index}`] = formatCellValue(description, val);
				return acc;
			}, {}),
		};
	}

	function buildMarketGrowthSheet(items, sheetName) {
		if (!items) return null;

		const monthTitles = Array.isArray(items?.titles) ? items?.titles : [];

		const rows = [
			makeRow(t('Gross Premium'), t('General Insurance'), items?.grossPremium?.GENERAL_INSURANCE),
			makeRow(t('Gross Premium'), t('Life Insurance'), items?.grossPremium?.LIFE_INSURANCE),
			makeRow(t('Gross Premium'), t('Total'), items?.grossPremium?.Total),

			makeRow(t('Number of Policies'), t('General Insurance'), items?.numPolicies?.GENERAL_INSURANCE),
			makeRow(t('Number of Policies'), t('Life Insurance'), items?.numPolicies?.LIFE_INSURANCE),
			makeRow(t('Number of Policies'), t('Total'), items?.numPolicies?.Total),

			makeRow(t('Sum Insured'), t('General Insurance'), items?.sumInsured?.GENERAL_INSURANCE),
			makeRow(t('Sum Insured'), t('Life Insurance'), items?.sumInsured?.LIFE_INSURANCE),
			makeRow(t('Sum Insured'), t('Total'), items?.sumInsured?.Total),

			makeRow(t('Gross Claim Incurred'), t('General Insurance'), items?.claimIncurred?.GENERAL_INSURANCE),
			makeRow(t('Gross Claim Incurred'), t('Life Insurance'), items?.claimIncurred?.LIFE_INSURANCE),
			makeRow(t('Gross Claim Incurred'), t('Total'), items?.claimIncurred?.Total),

			makeRow(t('Gross Claim Paid'), t('General Insurance'), items?.claimPaid?.GENERAL_INSURANCE),
			makeRow(t('Gross Claim Paid'), t('Life Insurance'), items?.claimPaid?.LIFE_INSURANCE),
			makeRow(t('Gross Claim Paid'), t('Total'), items?.claimPaid?.Total),
		];

		return {
			name: sheetName,
			titles: monthTitles,
			data: rows,
		};
	}

	useEffect(() => {
		const sheets = [];

		if (marketGrowthItem) {
			sheets.push(buildMarketGrowthSheet(marketGrowthItem, `${lang === 'en' ? `Monthly Martket Growth ${year}` : `កំណើនប្រចាំខែគ.ស ${year}`}`));
		}

		setData(sheets.filter(Boolean));
	}, [tab, marketGrowthItem, lang]);

	return (
		<Box {...props}>
			<ExcelFile
				filename={fileNameSummarizedReport(null, year)}
				element={
					<Button
						leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
						colorScheme="gray"
						variant="solid"
						size="sm"
						borderRadius={c.borderRadius}
						border="1px solid #bdc3c7"
					>
						{t('Export')}
					</Button>
				}
			>
				{data?.map((el, i) => {
					return (
						<ExcelSheet key={`sheet-${i}`} data={el?.data} name={t(el?.name)}>
							<ExcelColumn label={lang === 'kh' ? 'បរិយាយ' : t('descriptionReport')} value="description" />
							<ExcelColumn label={lang === 'kh' ? 'ប្រភេទធានារ៉ាប់រង' : t('Type of Insurance')} value="insuranceType" />
							{el?.titles?.map((title, index) => (
								<ExcelColumn key={index} label={lang === 'kh' ? title?.labelKh || title?.labelEn : title?.labelEn} value={`month_${index}`} />
							))}
						</ExcelSheet>
					);
				})}
			</ExcelFile>
		</Box>
	);
}
